<template>
  <div id="app">
    <el-container>
      <el-header height="70px" style="border-bottom: 1px solid #fafafa;">
        <Header />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer height="166px" v-if="showW != 1">
        <Footer />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { loadTemplate } from '@/api/api'
import Header from './components/Header'
import Footer from './components/Footer'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      showW: 0
    };
  },
  created() {
    this.getTemplate()
    this.showW = localStorage.getItem('showWitch') || 0
  },
  provide() {
    return {
      showWitch: () => {
        return this.showW
      }
    }
  },
  methods: {
    getTemplate() {
      loadTemplate().then(res => {
        if(res.success) {
          let template = res.data.find(item => {
            return item.category === 4
          })
          this.showW = template ? template.type : 0
          
          localStorage.setItem('showWitch', this.showW)
        }
      })
    }
  },
  watch: {
    
  }
};
</script>

<style lang="scss" scoped>
#app {
  /deep/ .el-main {
    padding: 0;
    min-height: calc(100vh - 236px);
  }
  /deep/ .el-footer {
    padding: 0;
  }
}
</style>
